"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DreamDAO = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _JsDreamDAO2 = require("./JsDreamDAO");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DreamDAO = /*#__PURE__*/function (_JsDreamDAO) {
  (0, _inherits2.default)(DreamDAO, _JsDreamDAO);

  var _super = _createSuper(DreamDAO);

  function DreamDAO(mapper, storeInterface, auth, firestore) {
    var _this;

    (0, _classCallCheck2.default)(this, DreamDAO);
    _this = _super.call(this, mapper, storeInterface, auth, firestore);
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }

  (0, _createClass2.default)(DreamDAO, [{
    key: "subscribeToMyDreamsListChanges",
    value: function subscribeToMyDreamsListChanges() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "subscribeToMyDreamsListChanges", this).call(this);
    }
  }, {
    key: "unsubscribeToMyDreamsListChanges",
    value: function unsubscribeToMyDreamsListChanges() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "unsubscribeToMyDreamsListChanges", this).call(this);
    }
  }, {
    key: "refreshDreamStateTree",
    value: function refreshDreamStateTree(dreamMap, dreamOrder) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "refreshDreamStateTree", this).call(this, dreamMap, dreamOrder);
    }
  }, {
    key: "getDream",
    value: function getDream(id) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "getDream", this).call(this, id);
    }
  }, {
    key: "setDream",
    value: function () {
      var _setDream = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dream) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "setDream", this).call(this, dream));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setDream(_x) {
        return _setDream.apply(this, arguments);
      }

      return setDream;
    }()
  }, {
    key: "deleteDream",
    value: function deleteDream(id) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "deleteDream", this).call(this, id);
    }
  }, {
    key: "setDreamOrder",
    value: function setDreamOrder(newOrderedList) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "setDreamOrder", this).call(this, newOrderedList);
    }
  }, {
    key: "addSparkToMyDreams",
    value: function () {
      var _addSparkToMyDreams = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(spark) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(DreamDAO.prototype), "addSparkToMyDreams", this).call(this, spark));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addSparkToMyDreams(_x2) {
        return _addSparkToMyDreams.apply(this, arguments);
      }

      return addSparkToMyDreams;
    }()
  }]);
  return DreamDAO;
}(_JsDreamDAO2.JsDreamDAO);

exports.DreamDAO = DreamDAO;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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